import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

const nextFocusedNode = createContext<string | null>(null);
const setNextFocusedNode = createContext<Dispatch<SetStateAction<string | null>>>(() => null);

const FlowPlotterController: FC<PropsWithChildren<object>> = ({ children }) => {
  const [currentFocus, setNextFocus] = useState<string | null>(null);

  return (
    <nextFocusedNode.Provider value={currentFocus}>
      <setNextFocusedNode.Provider value={setNextFocus}>{children}</setNextFocusedNode.Provider>
    </nextFocusedNode.Provider>
  );
};

export const _useRequestedNodeToPan = () => useContext(nextFocusedNode);
export const useSetNodeToPan = () => useContext(setNextFocusedNode);

export default FlowPlotterController;
